import { render, staticRenderFns } from "./close.vue?vue&type=template&id=0edff7d7"
import script from "./close.vue?vue&type=script&lang=js"
export * from "./close.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports